import { MapTo } from '@adobe/aem-react-editable-components';
import Billboard, { BillboardEditConfig } from './Billboard';

export default MapTo('cob-corp-acquisition/components/creditonebank/billboard')(Billboard, BillboardEditConfig);